<template>
  <v-container fluid class="config-layout pa-4">
    <v-row>
      <!-- Panel derecho -->
      <v-col cols="10" class="right-panel">
        <!-- Fila: Círculo + (Nombre del proyecto y Fechas) -->
        <v-row align="center" class="circle-and-fields">
          <!-- Círculo para el icono -->
          <v-col cols="3" class="d-flex justify-center">
            <div class="big-circle" @click="getIconUrl">
              <template v-if="this.$store.state.newProject.iconUrl">
                <img :src="this.$store.state.newProject.iconUrl" alt="Icono de la aplicación" />
              </template>
              <template v-else>
                <span>Insertar link</span>
              </template>
            </div>
          </v-col>

          <!-- Inputs de Nombre + Fechas -->
          <v-col cols="9">
            <!-- Nombre del proyecto -->
            <v-text-field
              label="Nombre de la aplicación"
              v-model="newProject.name"
              dense
              outlined
              hide-details
            ></v-text-field>

            <!-- Nombre de la pestaña de la aplicación -->
            <v-text-field
              class="mt-4"
              label="Nombre de la pestaña"
              v-model="newProject.tabName"
              dense
              outlined
              hide-details
            ></v-text-field>

            <!-- Fechas (selector nativo) -->
            <div class="two-dates input-group-with-line mt-4">
              <!-- Fecha de inicio -->
              <v-text-field
                type="date"
                label="Fecha de inicio"
                v-model="newProject.projectDateI"
                dense
                outlined
                hide-details
              ></v-text-field>

              <!-- Fecha de finalización -->
              <v-text-field
                type="date"
                label="Fecha de finalización"
                v-model="newProject.projectDateT"
                dense
                outlined
                hide-details
              ></v-text-field>
            </div>
          </v-col>
        </v-row>

        <!-- Tipo de proyecto -->
        <v-text-field 
          class="mt-5"
          label="Tipo de aplicación"
          v-model="newProject.typeProject"
        />

        <!-- Descripción -->
        <v-textarea
          class="mt-5"
          label="Descripción"
          rows="4"
          outlined
          dense
          v-model="newProject.description"
        ></v-textarea>

        <!-- Puntaje de tareas -->
        <v-radio-group
          v-model="newProject.taskScore"
          label="Puntaje de tareas"
          class="mt-4"
          row
        >
          <v-radio label="Todas valen igual" value="equal" color="primary"></v-radio>
          <v-radio label="Dificultad (fácil/mediana/difícil)" value="difficulty" color="primary"></v-radio>
          <v-radio label="Manual" value="manual" color="primary"></v-radio>
        </v-radio-group>

        <!-- Integrantes -->
        <v-text-field
          label="Integrantes"
          class="mt-4"
          outlined
          dense
          v-model="integranteInput"
          @keydown.enter.prevent="addIntegrante"
          @blur="addIntegrante"
        ></v-text-field>
        <!-- Mostrar integrantes como tags -->
        <v-row>
          <v-chip
            v-for="(item, index) in newProject.userMembers"
            :key="index"
            class="ma-1"
            close
            @click="removeIntegrante(index)"
          >
            {{ item }}
          </v-chip>
        </v-row>

        <!-- Roles -->
        <v-text-field
          label="Roles"
          class="mt-4"
          outlined
          dense
          v-model="rolInput"
          @keydown.enter.prevent="addRol"
          @blur="addRol"
        ></v-text-field>
        <!-- Mostrar roles como tags -->
        <v-row>
          <v-chip
            v-for="(item, index) in rolesList"
            :key="index"
            class="ma-1"
            close
            @click="removeRol(index)"
          >
            {{ item }}
          </v-chip>
        </v-row>
        <!-- Nombre especial para los subproyectos -->
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Nombre especial para los subproyectos (comisión, comité, etc.)"
              outlined
              dense
              v-model="newProject.subprojectName"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>


    <v-row>
      <!-- Botón de continuar -->
      <v-col cols="12" class="d-flex justify-end mt-5">
      <v-btn color="primary" @click="continuar" class="animated-button">Continuar</v-btn>
      </v-col>
    </v-row>

    <!-- <button @click="test">test</button> -->

    <!-- Snackbar para mensajes de error -->
    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      bottom
      color="error"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "ProjectConfigLayout",
  computed: {
    newProject: {
      get() {
        return this.$store.state.newProject;
      },
      set(value) {
        this.$store.commit("updateNewProject", value);
      },
    }
  },
  data() {
    return {
      // Integrantes
      integranteInput: "",  // Input para agregar integrantes
      // integrantesList: [localStorage.getItem('email')],  // Lista de integrantes

      // Roles
      rolInput: "",  // Input para agregar roles
      rolesList: ['admin'],  // Lista de roles

      // Snackbar (ui)
      snackbar: false,
      snackbarText: "",
    };
  },
  methods: {
    async getIconUrl() {
      const iconUrl = prompt("Ingresa el link de la imagen para el icono del proyecto");
      if (iconUrl) {
        this.$store.state.newProject.iconUrl = iconUrl;
        console.log('url cambiada: ', this.$store.state.newProject.iconUrl);
      }
    },
    addIntegrante() {
      const valor = this.integranteInput.trim();
      if (valor) {
        this.$store.state.newProject.userMembers.push(valor);
        this.integranteInput = "";
      }
    },
    addRol() {
      const valor = this.rolInput.trim();
      if (valor) {
        this.rolesList.push(valor);
        this.rolInput = "";
      }
    },
    removeIntegrante(index) {
      this.$store.state.newProject.userMembers.splice(index, 1);
    },
    removeRol(index) {
      this.rolesList.splice(index, 1);
    },
    continuar() {
      // Capturamos lo que pueda quedar en los inputs
      this.addIntegrante();
      this.addRol();

      if (
        !this.$store.state.newProject.name ||
        !this.$store.state.newProject.projectDateI ||
        !this.$store.state.newProject.projectDateT ||
        !this.$store.state.newProject.description ||
        this.$store.state.newProject.userMembers.length === 0 ||
        this.rolesList.length === 0
      ) {
        this.snackbarText = "Por favor llena todos los campos";
        this.snackbar = true;
        return;
      }

      // Guardar datos en el store
      this.$store.state.newProject.members = this.$store.state.newProject.userMembers
      this.$store.state.newProject.userTypes = this.rolesList;

      // Cambiar vista
      this.$store.state.cms_view++;
    },
    test() {
      console.log("data()", this);
    },
  },
  created(){
    if(!this.$route.params.projectId){
      this.$store.commit('updateNewProject', {
        projectDateI: new Date().toISOString().substr(0, 10),
        projectDateT: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().substr(0, 10),
        description: "[Descripción del proyecto]",
        taskScore: "equal",
      });
    }
  },
};
</script>

<style scoped>
.config-layout {
  height: 100vh;
  overflow-x: hidden;
}
.left-panel {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 30px;
}
.step-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
}
.step-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ccc;
  color: #fff;
  text-align: center;
  line-height: 24px;
  margin-right: 10px;
}
.step-text {
  font-weight: 500;
}
.step-line {
  width: 2px;
  background-color: #ccc;
  margin: 0 auto;
  flex-shrink: 0;
  height: 60px;
}
.right-panel {
  padding: 20px;
}
.big-circle {
  width: 15vw;
  height: 15vw;
  max-width: 200px;
  max-height: 200px;
  border-radius: 50%;
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
}
.big-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.circle-and-fields {
  margin-bottom: 20px;
}
.input-group-with-line {
  position: relative;
  display: flex;
  gap: 16px;
  padding: 10px 0;
}
.v-text-field,
.v-textarea {
  margin-bottom: 0;
}

.type-project-selector{
  cursor: pointer;
  border-radius: 5%;
}


.type-project-selector:hover{
  border: 2px solid #14B8A6;
}

.type-project-selector-selected{
  background-color: #14b8a563;
}

.animated-button {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
</style>
